import { FC } from 'react';
import { twMerge } from '@utils/twMerge';
type AvatarProps = {
  userName: string;
  nameSeparator?: string;
  className?: string;
};
export const Avatar: FC<AvatarProps> = ({ userName, nameSeparator = ' ', className }) => {
  const initials =
    userName
      ?.split(nameSeparator)
      .slice(0, 2)
      .map(([part]) => part?.toUpperCase())
      .join('') ?? 'U';
  return (
    <div
      className={twMerge(
        'flex h-[3.2rem] w-[3.2rem] min-h-[3.2rem] min-w-[3.2rem] items-center justify-center rounded-full bg-brightGray text-1432 font-medium text-black', className
      )}
    >
      {initials}
    </div>
  );
};
